import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.475",
  height: "19.238",
  viewBox: "0 0 19.475 19.238"
}
const _hoisted_2 = {
  id: "Icon_feather-eye-off",
  "data-name": "Icon feather-eye-off",
  transform: "translate(0.827 0.707)"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconEye',
  props: {
    classStroke: { default: null },
    show: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _withDirectives(_createElementVNode("path", {
        id: "line",
        class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
        d: "M1.5,1.5,19.323,19.324",
        transform: "translate(-1.5 -1.5)",
        fill: "none",
        stroke: "#888f94",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 2), [
        [_vShow, !_ctx.show]
      ]),
      _createElementVNode("path", {
        id: "Path_7872",
        class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
        "data-name": "Path 7872",
        d: "M1.5,12.355S4.677,6,10.237,6s8.737,6.355,8.737,6.355-3.177,6.355-8.737,6.355S1.5,12.355,1.5,12.355Z",
        transform: "translate(-1.327 -3.639)",
        fill: "none",
        stroke: "#888f94",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 2),
      _createElementVNode("path", {
        id: "Path_7873",
        class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
        "data-name": "Path 7873",
        d: "M19.341,16.421A2.92,2.92,0,1,1,16.42,13.5,2.92,2.92,0,0,1,19.341,16.421Z",
        transform: "translate(-7.51 -7.705)",
        fill: "none",
        stroke: "#888f94",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 2)
    ])
  ]))
}
}

})